/**
 * Traduz UMA VEZ os nomes de categoria e de grupo que o app cria sozinho
 * quando um arquivo novo nasce.
 *
 * POR QUE ISTO EXISTE: esses nomes não passam pelo i18n — eles vêm gravados em
 * inglês dentro de `loot-core/default-db.sqlite` e são copiados para o banco do
 * arquivo na criação. Ou seja, a tela de Orçamento (a principal do app nativo)
 * abria em inglês por mais completa que fosse a tradução da interface.
 *
 * ⛔ POR QUE NÃO TRADUZIR O `default-db.sqlite`: (a) não conserta o arquivo de
 * quem já usa o app, porque lá os nomes já estão gravados; (b) 17 pontos de
 * teste do upstream casam por esses nomes (`e2e/budget.test.ts`,
 * `TransactionsTable.test.tsx`, `budget/queries.ts`…), então viraria conflito
 * em todo rebase.
 *
 * ⚠️ AS TRAVAS, porque isto ESCREVE no dado do dono:
 *  1. só renomeia nome IGUAL, byte a byte, ao padrão do upstream — nome que ele
 *     escreveu fica intocado;
 *  2. é idempotente por construção: depois de renomeado, nenhum nome casa mais
 *     com o padrão em inglês. ⚠️ NÃO há flag de "já rodei" — o único caso que
 *     isso deixa em aberto é o dono renomear DE VOLTA para "Food"/"Bills", que
 *     seria retraduzido na recarga seguinte. Aceito por ser implausível, e o
 *     custo de uma flag seria um campo novo em `MetadataPrefs` do upstream;
 *  3. só em português — em qualquer outro idioma é no-op;
 *  4. cada renomeação é independente: o que falhar fica em inglês, sem
 *     derrubar o app nem deixar o resto pela metade.
 */

export const NOMES_PADRAO: Record<string, string> = {
  // grupos
  'Usual Expenses': 'Despesas do dia a dia',
  'Investments and Savings': 'Investimentos e reservas',
  // grupo e categoria têm o mesmo nome no upstream
  Income: 'Receitas',
  // categorias
  Food: 'Alimentação',
  General: 'Geral',
  Bills: 'Contas fixas',
  'Bills (Flexible)': 'Contas variáveis',
  Savings: 'Reserva',
};

/**
 * ⛔ 'Starting Balances' fica de FORA de propósito: o upstream já a traduz na
 * exibição (`budget/queries.ts` → `translateStartingBalancesCategory`), então
 * o nome que chega aqui já vem em português e nunca casaria. Renomear no banco
 * ainda quebraria aquele tradutor, que compara com a frase em inglês.
 */

type Nomeado = { id: string; name: string };

export function traducaoDe(nome: string): string | undefined {
  return Object.hasOwn(NOMES_PADRAO, nome) ? NOMES_PADRAO[nome] : undefined;
}

/** O que seria renomeado — separado do envio para poder ser testado sozinho. */
export function planoDeTraducao(itens: readonly Nomeado[]) {
  return itens
    .map(i => ({ id: i.id, de: i.name, para: traducaoDe(i.name) }))
    .filter((p): p is { id: string; de: string; para: string } => !!p.para);
}

export function ehPortugues(idioma: string | undefined | null): boolean {
  return !!idioma && idioma.toLowerCase().startsWith('pt');
}
